import React from "react";
import { createBrowserHistory } from "history";
import { applyMiddleware, legacy_createStore as createStore } from "redux";
import { promiseMiddleware } from "@adobe/redux-saga-promise";

import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import PropTypes from "prop-types";
import rootSaga from "../sagas";
import rootReducer from "../reducers";

let composeWithDevTools;
if (process.env.NODE_ENV === "development") {
  composeWithDevTools =
    require("@redux-devtools/extension").composeWithDevTools;
}

let reduxStore;
const sagaMiddleware = createSagaMiddleware();

const configureStore = () => {
  return createStore(
    rootReducer,
    process.env.NODE_ENV === "development"
      ? composeWithDevTools(applyMiddleware(promiseMiddleware, sagaMiddleware))
      : applyMiddleware(promiseMiddleware, sagaMiddleware)
  );
};
reduxStore = configureStore();
sagaMiddleware.run(rootSaga);

const Store = ({ children }) => (
  <Provider store={reduxStore}>{children}</Provider>
);
Store.propTypes = {
  children: PropTypes.node,
};

export const browserHistory = createBrowserHistory();

export default Store;
